import { companyProfileFormSelectors } from 'selectors/hiring';

import buildFormField from 'components/forms/FormField';

export default buildFormField(
  'COMPANY_PROFILE_FORM',
  companyProfileFormSelectors
);
